<dx-scroll-view
  height="100%"
  width="100%"
  class="view-wrapper-scroll single-card"
>
  <card-auth [title]="title" [description]="description">
    <ng-content></ng-content>
  </card-auth>
</dx-scroll-view>
